var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { staticClass: "dashboard-filters", attrs: { align: "center", dense: "" } },
    [
      _c(
        "v-col",
        { attrs: { cols: "auto" } },
        [
          _c("v-select", {
            staticStyle: { width: "220px" },
            attrs: {
              dense: "",
              "hide-details": "",
              items: _vm.rangeOptions,
              label: _vm.$t("labels.dateRange"),
              outlined: ""
            },
            model: {
              value: _vm.rangeOption,
              callback: function($$v) {
                _vm.rangeOption = $$v
              },
              expression: "rangeOption"
            }
          })
        ],
        1
      ),
      _vm.rangeOption === "custom"
        ? _c(
            "v-col",
            { attrs: { cols: "auto" } },
            [
              _c(
                "v-menu",
                {
                  attrs: {
                    "close-on-content-click": false,
                    "min-width": "auto",
                    "offset-y": ""
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          var attrs = ref.attrs
                          return [
                            _c(
                              "v-text-field",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "custom-range",
                                    staticStyle: { width: "260px" },
                                    attrs: {
                                      dense: "",
                                      "hide-details": "",
                                      outlined: "",
                                      readonly: "",
                                      value: _vm.customRangeText
                                    }
                                  },
                                  "v-text-field",
                                  attrs,
                                  false
                                ),
                                on
                              )
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    1726827435
                  ),
                  model: {
                    value: _vm.showCustomRange,
                    callback: function($$v) {
                      _vm.showCustomRange = $$v
                    },
                    expression: "showCustomRange"
                  }
                },
                [
                  _c("v-date-picker", {
                    attrs: { "no-title": "", range: "" },
                    on: { change: _vm.applyCustomRange },
                    model: {
                      value: _vm.customRangeDraft,
                      callback: function($$v) {
                        _vm.customRangeDraft = $$v
                      },
                      expression: "customRangeDraft"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      !_vm.isDepartmentManagement
        ? _c(
            "v-col",
            { attrs: { cols: "auto" } },
            [
              _c("v-select", {
                staticClass: "departments",
                staticStyle: { width: "260px" },
                attrs: {
                  clearable: "",
                  dense: "",
                  "hide-details": "",
                  "item-text": "name",
                  "item-value": "id",
                  items: _vm.departments,
                  label: _vm.$tc("labels.department", 2),
                  multiple: "",
                  outlined: "",
                  placeholder: _vm.$t("labels.all")
                },
                model: {
                  value: _vm.departmentIds,
                  callback: function($$v) {
                    _vm.departmentIds = $$v
                  },
                  expression: "departmentIds"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c("v-spacer"),
      _c(
        "v-col",
        {
          staticClass: "range-text body-2 grey--text text--darken-1",
          attrs: { cols: "auto" }
        },
        [_vm._v("\n    " + _vm._s(_vm.rangeText) + "\n  ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }